import { EuiFormRow } from '@equipmentshare/ds2'
import { FormRowProps } from './types'

export default function FormRowEui( props: FormRowProps ) {
	return <EuiFormRow {...props} />
}
